var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloneIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.782,
    height: 17,
    viewBox: "0 0 15.782 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11366",
    "data-name": "Path 11366",
    d: "M14.362,6.149l-.439-.483-.734,0H11.518L9.653,3.8,9.124,3.3H2.165l.681.638L2.165,3.3V16.042h4.71V18.4H17.258V9.019l-.485-.457ZM6.875,7.914v7.172H3.128V4.267h5.6l.248.213,1.186,1.186H6.875V7.911ZM16.3,16.16v1.284H7.84V6.628h5.65l.191.205L16.1,9.246l.2.194v6.72ZM17.805,4.4,16.566,5.642a.481.481,0,0,1-.68,0L14.648,4.4a.481.481,0,0,1,.68-.68l.413.413a1.822,1.822,0,0,0-1.818-1.774h-1.09a.481.481,0,1,1,0-.963h1.09A2.784,2.784,0,0,1,16.7,4.143l.422-.421a.482.482,0,0,1,.68.682Z",
    transform: "translate(-2.165 -1.4)",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/cloneIcon.368f802772a2eb443942a3245d0f9aa9.svg";
export { ForwardRef as ReactComponent };